// Purpose: shared formatters for bytes, dates, and relative times. Lifted
// from the per-page duplications in Shares / ShareDetail / Dropboxes so
// Phase 7 admin pages do not add a third copy.

export function formatBytes(n: number | bigint | string): string {
  const value = typeof n === 'string' ? BigInt(n) : typeof n === 'bigint' ? n : BigInt(n);
  if (value < 1024n) return `${value} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let v = Number(value);
  let u = -1;
  while (v >= 1024 && u < units.length - 1) {
    v /= 1024;
    u += 1;
  }
  return `${v.toFixed(v >= 10 ? 0 : 1)} ${units[u]}`;
}

export function formatDateTime(iso: string | Date | null | undefined): string {
  if (!iso) return '—';
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString();
}

// "5 minutes ago", "2 days ago", "just now". Negative values return "in the future".
export function formatRelative(iso: string | Date | null | undefined, now = new Date()): string {
  if (!iso) return '—';
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  if (Number.isNaN(d.getTime())) return '—';
  const diffMs = now.getTime() - d.getTime();
  const seconds = Math.floor(diffMs / 1000);
  if (seconds < 0) return 'in the future';
  if (seconds < 5) return 'just now';
  if (seconds < 60) return `${seconds} s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days} d ago`;
  return formatDateTime(d);
}
